import { render, staticRenderFns } from "./SecondRow.vue?vue&type=template&id=61550da0&scoped=true"
import script from "./SecondRow.vue?vue&type=script&lang=js"
export * from "./SecondRow.vue?vue&type=script&lang=js"
import style0 from "./SecondRow.vue?vue&type=style&index=0&id=61550da0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61550da0",
  null
  
)

export default component.exports